export enum ExceptionalJobModalState {
  CreateCabinetConfig = 'createCabinetConfig',
  EditCabinetConfig = 'editCabinetConfig',
  EditDocumentType = 'editDocumentType',
  CreateDocumentType = 'createDocumentType'
}
